/* Restaurant Halong 2026-10-09 (Konzept 2): Allergen- und Zusatzstoff-Kürzel im Gerichtsnamen, z. B. „(A, F)“ oder
   „(2, 4)“, klein und grau statt in Titelgröße (Karim 09.10.). Nur Klammern aus Kürzeln a–n bzw. ein- oder zweistelligen
   Zahlen; „(Rind)“ o. ä. bleibt unverändert. Nur die Anzeige ändert sich, der Produkttitel (Warenkorb, Kasse, Bon) bleibt. */
(function () {
  var KUERZEL = /\((?:[A-Na-n]|\d{1,2})(?:\s*,\s*(?:[A-Na-n]|\d{1,2}))*\)/g;
  var ZIELE = '.product-card__title, .halong-bestseller__name, .stepsFormHeader';

  function teilen(knoten) {
    var text = knoten.nodeValue;
    KUERZEL.lastIndex = 0;
    if (!KUERZEL.test(text)) return;
    KUERZEL.lastIndex = 0;
    var teile = document.createDocumentFragment();
    var letzte = 0;
    var treffer;
    while ((treffer = KUERZEL.exec(text))) {
      teile.appendChild(document.createTextNode(text.slice(letzte, treffer.index)));
      var code = document.createElement('span');
      code.className = 'hk-code';
      code.textContent = treffer[0];
      teile.appendChild(code);
      letzte = treffer.index + treffer[0].length;
    }
    teile.appendChild(document.createTextNode(text.slice(letzte)));
    knoten.parentNode.replaceChild(teile, knoten);
  }

  function dezent() {
    document.querySelectorAll(ZIELE).forEach(function (titel) {
      var gang = document.createTreeWalker(titel, NodeFilter.SHOW_TEXT);
      var knoten = [];
      while (gang.nextNode()) knoten.push(gang.currentNode);
      knoten.forEach(function (k) {
        if (k.parentElement && k.parentElement.closest('.hk-code, svg')) return;
        teilen(k);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', dezent);
  else dezent();
})();

/* Restaurant Halong 2026-10-10 (Karim): Bestseller im leeren Warenkorb öffnen das Gericht-Fenster. Auf der Speisekarte
   direkt (Drawer zu, Fenster auf, wie die Reihe „Am häufigsten bestellt“), auf anderen Seiten folgt der Link nach
   /collections/speisekarte?gericht=<Produkt-ID>; dort öffnet sich das Fenster nach dem Laden. */
(function () {
  function oeffne(id) {
    var opener = document.querySelector('[data-popup-open="' + id + '"]');
    var popup = document.querySelector('[data-popup="' + id + '"]');
    if (!opener || !popup) return false;
    // Das Fenster liegt in der Kategorie weiter unten; deren Einblend-Container ist bis zum Hineinscrollen unsichtbar.
    var reveal = popup.closest('reveal-items');
    if (reveal) reveal.style.opacity = '1';
    if (window.jQuery) { window.jQuery(opener).trigger('click'); } else { opener.click(); }
    return true;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-halong-gericht]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var id = link.getAttribute('data-halong-gericht');
    if (!document.querySelector('[data-popup-open="' + id + '"]')) return; // andere Seite: normaler Link
    event.preventDefault();
    var drawer = link.closest('cart-drawer');
    if (drawer && typeof drawer.hide === 'function') drawer.hide();
    setTimeout(function () { oeffne(id); }, drawer ? 450 : 0);
  });

  var gericht = null;
  try { gericht = new URLSearchParams(window.location.search).get('gericht'); } catch (e) { gericht = null; }
  if (gericht && /^\d+$/.test(gericht)) {
    window.addEventListener('load', function () {
      if (!oeffne('popup-' + gericht) || !window.history.replaceState) return;
      var url = new URL(window.location.href);
      url.searchParams.delete('gericht');
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    });
  }
})();
